import React from "react";
import styles from "./SecondaryAuthLayout.module.css";
import Grid from "@mui/material/Unstable_Grid2";
import { Container } from "@mui/system";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import auth_frame from "assets/images/auth-frame2.png";
import GoBack from "../goBack/GoBack";

function SecondaryAuthLayout({ children }) {
  return (
    <div className={styles.secondary_auth_layout}>
      <Grid container>
        <Grid
          xs={12}
          lg={4}
          sx={{
            display: {
              xs: "none",
              lg: "inline-block",
            },
          }}
        >
          <div className={styles.auth_frame_img}>
            <img src={auth_frame} alt="" />
          </div>
        </Grid>
        <Grid xs={12} lg={8}>
          <Container maxWidth="md">
            <div className={`${styles.content} ${styles.scrollbar_hidden}`}>
              <div className={styles.heading}>
                <GoBack />
                <div className={styles.signup}>
                  <Typography>
                    Don’t have an account? Proceed to{" "}
                    <Link to="/signup">Sign up</Link>
                  </Typography>
                </div>
              </div>

              {children}
            </div>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}

export default SecondaryAuthLayout;
